module.exports = __webpack_public_path__ + "img/Tut_Map.c408b0e2.png";